import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getNote, getProject } from '../../content/portfolioContent';

export default function RouteNavigation() {
  const location = useLocation();
  const previousPath = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    const project = path.startsWith('/projects/') && getProject(path.split('/')[2]);
    const note = path.startsWith('/notes/') && getNote(path.split('/')[2]);
    const titles = { '/': 'Software engineer', '/notes': 'Working notes', '/background': 'Background & capabilities', '/credits': 'Credits' };
    const title = project?.title || note?.title || titles[path] || (path.startsWith('/connect') ? 'Connect' : 'Page not found');
    document.title = `${title} — Robert Miller`;

    // Native fragment scrolling can run before React mounts the destination.
    // Resolve it again once this route's content has committed, including on reload.
    const frame = window.requestAnimationFrame(() => {
      let targetId = location.hash.slice(1);
      try { targetId = decodeURIComponent(targetId); } catch { /* Ignore malformed fragments. */ }
      const target = targetId && document.getElementById(targetId);
      if (target) target.scrollIntoView({ block: 'start', behavior: 'auto' });
      else if (previousPath.current !== path) window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      previousPath.current = path;
    });
    return () => window.cancelAnimationFrame(frame);
  }, [location.pathname, location.hash, location.key]);

  return null;
}
